import React from 'react';

import {
  Flex, HStack, Stack, Text,
} from '@chakra-ui/react';

import { Button, Icon } from 'components';

export default function TrainingItems({ contents, disabled = false, ...rest }) {
  return (
    <Stack {...rest}>
      <Text variant="xLargeBold">Conteúdo</Text>
      {contents.map(({ label, url }) => (
        <Button
          onClick={() => window.open(url, '_blank')}
          onAuxClick={() => window.open(url, '_blank')}
          disabled={disabled}
          color="gray.600"
          _hover={{
            bg: 'secondary.700',
            color: 'white.default',
          }}
          bg="white.default">
          <Flex
            px={6}
            width="100%"
            justifyContent="space-between">
            <Text
              variant="mediumBold">
              {label}
            </Text>
            <HStack
              cursor="pointer">
              <Text
                variant="xSmallRegular">Acessar conteúdo
              </Text>
              <Icon
                name="play"
                color="primary.default"
              />
            </HStack>
          </Flex>
        </Button>
      ))}
    </Stack>
  );
}
